export default __webpack_public_path__ + "static/object-tile-smaller-dont-e8c45975e36dd17904b7d0b12df409d85923ee6d908fd85183b0d410bb0cbe0e.png";